<template>
    <a href="/">
<!--        <svg class="w-16 h-16" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--            <path d="M11.395 44.428C4.557 40.198 0 32.632 0 24 0 10.745 10.745 0 24 0a23.891 23.891 0 0113.997 4.502c-.2 17.907-11.097 33.245-26.602 39.926z" fill="#6875F5"/>-->
        <!--            <path d="M14.134 45.885A23.914 23.914 0 0024 48c13.255 0 24-10.745 24-24 0-3.516-.756-6.856-2.115-9.866-4.659 15.143-16.608 27.092-31.75 31.751z" fill="#6875F5"/>-->
        <!--        </svg>-->
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
             width="300.000000pt" height="96.000000pt" viewBox="0 0 300.000000 96.000000"
             preserveAspectRatio="xMidYMid meet">
            <metadata>
                Created by potrace 1.10, written by Peter Selinger 2001-2011
            </metadata>
            <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
               fill="#000000" stroke="none">
                <path d="M220 670 l0 -150 149 0 150 0 3 150 3 150 -152 0 -153 0 0 -150z
m261 112 c0 -14 2 -14 9 3 5 13 9 -29 9 -111 l1 -132 -97 0 c-54 0 -113 2
-130 4 l-33 5 0 92 c0 55 4 87 9 78 6 -9 9 -5 9 14 0 16 -4 22 -8 15 -4 -7 -7
-1 -7 15 0 16 3 22 7 15 5 -9 9 -8 13 2 4 11 30 15 111 16 94 2 106 0 107 -16z"/>
                <path d="M348 773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
                <path d="M307 739 c-15 -9 -18 -22 -15 -81 1 -38 8 -74 15 -79 14 -12 53 5 53
23 0 6 11 1 24 -12 30 -27 61 -21 53 11 -3 12 -1 33 4 47 6 15 8 36 4 49 -10
42 -94 67 -138 42z m101 -25 c26 -18 28 -41 5 -66 -15 -17 -15 -19 2 -38 16
-17 16 -20 2 -20 -9 0 -19 9 -22 20 -4 14 -15 20 -35 20 -23 0 -27 -3 -23 -20
3 -13 0 -20 -8 -20 -11 0 -13 16 -11 70 l4 70 32 0 c17 0 42 -7 54 -16z"/>
                <path d="M335 680 c0 -26 4 -30 26 -30 15 0 32 7 39 15 17 21 -4 45 -39 45
-22 0 -26 -4 -26 -30z m55 6 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11
10 11 6 0 10 -2 10 -4z"/>
                <path d="M540 591 l0 -150 150 -3 150 -3 0 153 0 152 -150 0 -150 0 0 -149z
m280 7 c0 -88 -3 -118 -12 -118 -9 0 -9 -3 1 -9 22 -14 -37 -21 -149 -18 l-95
2 -3 127 c-3 148 -19 134 151 135 l107 0 0 -119z"/>
                <path d="M680 662 c-19 -2 -40 -7 -45 -12 -14 -12 -11 -153 4 -158 6 -2 8 -9
5 -15 -5 -8 -2 -8 7 1 16 14 43 16 34 2 -3 -5 -1 -10 4 -10 6 0 11 4 11 9 0 5
12 11 27 13 32 4 39 20 19 41 -8 8 -13 17 -10 20 3 3 7 25 10 51 5 52 -8 64
-66 58z m60 -32 c0 -5 -18 -10 -40 -10 -33 0 -40 -3 -40 -20 0 -16 7 -20 35
-20 19 0 35 -5 35 -11 0 -6 -14 -9 -31 -7 -27 2 -33 -1 -36 -21 -3 -21 0 -23
37 -19 29 2 40 0 40 -10 0 -9 -13 -12 -47 -10 l-48 3 -2 68 -1 67 49 0 c27 0
49 -4 49 -10z"/>
                <path d="M728 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
                <path d="M1000 459 c0 -157 1 -170 18 -167 14 3 16 13 14 65 -2 34 -1 66 2 71
3 5 21 6 41 3 30 -5 40 -14 73 -71 26 -45 44 -66 60 -68 12 -2 22 0 22 3 0 4
-20 38 -46 77 -25 39 -44 71 -42 73 2 1 13 8 26 14 29 16 45 57 37 99 -9 49
-53 72 -137 72 l-68 0 0 -171z m153 110 c41 -50 5 -99 -73 -99 l-50 0 0 66 0
67 53 -7 c35 -4 58 -14 70 -27z"/>
                <path d="M1282 464 l3 -165 93 -2 c82 -2 92 0 92 16 0 15 -10 17 -75 17 l-75
0 0 60 0 60 70 0 c63 0 70 2 70 20 0 18 -7 20 -70 20 l-70 0 0 53 0 52 75 -3
c71 -4 75 -3 75 17 0 20 -5 21 -95 21 l-95 0 2 -166z"/>
                <path d="M1547 463 c2 -154 4 -168 20 -168 16 0 18 9 17 73 l0 72 73 0 c58 0
73 3 73 15 0 12 -15 15 -73 15 l-73 0 2 62 1 62 73 0 c62 1 73 4 76 19 2 15
-8 17 -94 17 l-97 0 2 -167z"/>
                <path d="M1790 463 l0 -168 92 2 c76 1 94 4 96 17 3 14 -8 16 -72 16 l-76 0 0
60 0 60 70 0 c63 0 70 2 70 20 0 18 -7 20 -70 20 l-70 0 0 53 0 52 75 -3 c71
-4 75 -3 75 17 0 20 -5 21 -95 21 l-95 0 0 -167z"/>
                <path d="M2050 459 c0 -157 1 -170 18 -167 14 3 17 15 18 68 1 36 4 66 8 68 3
1 19 2 35 2 26 0 34 -8 68 -67 28 -49 45 -69 62 -71 13 -2 22 0 20 5 -12 26
-72 124 -80 129 -15 9 -10 22 11 29 30 10 53 61 45 102 -9 50 -52 73 -137 73
l-68 0 0 -171z m114 131 c44 -10 56 -23 56 -62 0 -36 -34 -58 -90 -58 l-45 0
2 62 c1 35 2 64 2 66 2 5 37 1 75 -8z"/>
                <path d="M2337 464 l2 -167 90 -1 c80 -1 91 1 91 17 0 15 -10 17 -73 17 l-73
0 1 60 0 60 73 0 c65 0 72 2 72 20 0 18 -7 20 -73 20 l-72 0 1 52 0 53 72 -3
c67 -4 72 -2 72 17 0 20 -5 21 -92 21 l-93 0 2 -166z"/>
                <path d="M2576 603 c9 -16 33 -51 52 -80 l34 -52 -47 -76 c-26 -41 -51 -78
-56 -81 -16 -9 -10 -24 10 -24 13 0 35 24 67 75 26 41 48 75 49 75 1 0 22 -34
46 -75 34 -58 49 -75 67 -75 12 0 22 1 22 3 0 2 -26 43 -59 92 l-58 89 44 60
c64 87 68 96 43 96 -15 0 -33 -19 -61 -65 -23 -36 -42 -65 -44 -65 -2 0 -20
29 -41 65 -30 50 -44 65 -63 65 -23 0 -23 0 -5 -27z"/>
                <path d="M220 350 l0 -150 150 0 150 0 0 150 0 150 -150 0 -150 0 0 -150z
m243 131 l37 -1 0 -124 c0 -145 10 -134 -133 -134 -139 0 -129 -11 -125 130 2
78 7 122 15 126 6 4 47 6 90 5 43 -1 95 -2 116 -2z"/>
                <path d="M315 440 c-8 -14 -10 -145 -1 -158 4 -7 31 -12 61 -12 46 0 55 3 61
22 4 14 1 25 -8 32 -12 9 -13 15 -4 29 8 14 8 20 -4 27 -8 5 -10 10 -4 10 18
0 26 31 13 46 -13 16 -105 19 -114 4z m105 -20 c0 -5 -18 -10 -40 -10 -33 0
-40 -3 -40 -20 0 -17 7 -20 40 -20 22 0 40 -4 40 -10 0 -5 -18 -10 -40 -10
-33 0 -40 -3 -40 -20 0 -17 7 -20 45 -20 25 0 45 -4 45 -10 0 -5 -24 -10 -54
-10 l-54 0 0 70 0 70 49 0 c27 0 49 -4 49 -10z"/>
                <path d="M538 270 l-3 -150 153 0 152 0 0 150 0 150 -149 0 -150 0 -3 -150z
m282 9 c0 -88 -3 -119 -12 -119 -9 0 -8 -4 2 -10 10 -7 -29 -10 -120 -9 -85 0
-128 4 -115 9 17 7 17 9 3 9 -16 1 -18 14 -18 120 l0 119 130 0 130 0 0 -119z"/>
                <path d="M640 362 c-26 -8 -29 -25 -12 -54 15 -26 15 -30 -1 -58 -10 -17 -15
-35 -12 -40 9 -14 48 -13 63 2 9 9 15 9 24 0 7 -7 22 -12 35 -12 18 0 22 5 20
29 -1 16 -6 29 -11 28 -5 -1 -10 12 -10 28 -1 25 3 29 19 27 15 -2 17 -1 6 6
-7 6 -11 14 -7 20 3 5 -1 15 -8 21 -11 9 -19 9 -35 -1 -16 -9 -26 -10 -38 -2
-10 6 -25 9 -33 6z m31 -38 l13 -26 23 28 c12 16 25 25 29 21 4 -4 -2 -17 -14
-30 -28 -29 -27 -31 4 -73 15 -19 21 -34 15 -34 -6 0 -20 14 -33 30 l-22 30
-19 -30 c-10 -16 -23 -30 -28 -30 -15 0 -10 13 15 45 l24 29 -25 33 c-19 24
-21 33 -11 33 8 0 21 -12 29 -26z"/>
            </g>
        </svg>
    </a>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';

    export default defineComponent({
        components: {
            Link,
        },
    })
</script>
